module.exports = __webpack_public_path__ + "static/media/water-delivery-power.2091b195.jpg";